var _defs, _polygon, _polygon2, _polygon3, _polygon4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPremiumPackage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        fill: url(#linear-gradient10);\n      }\n\n      .st2 {\n        fill: url(#linear-gradient21);\n      }\n\n      .st3 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st4 {\n        fill: url(#linear-gradient9);\n      }\n\n      .st5 {\n        fill: url(#linear-gradient18);\n      }\n\n      .st6 {\n        fill: url(#linear-gradient23);\n      }\n\n      .st7 {\n        fill: url(#linear-gradient8);\n      }\n\n      .st8 {\n        fill: url(#linear-gradient11);\n      }\n\n      .st9 {\n        fill: url(#linear-gradient16);\n      }\n\n      .st10 {\n        fill: url(#linear-gradient22);\n      }\n\n      .st11 {\n        fill: url(#linear-gradient19);\n      }\n\n      .st12 {\n        fill: url(#linear-gradient12);\n      }\n\n      .st13 {\n        fill: url(#linear-gradient7);\n      }\n\n      .st14 {\n        fill: url(#linear-gradient20);\n      }\n\n      .st15 {\n        fill: url(#linear-gradient4);\n      }\n\n      .st16 {\n        fill: url(#linear-gradient14);\n      }\n\n      .st17 {\n        fill: url(#linear-gradient5);\n      }\n\n      .st18 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st19 {\n        fill: url(#linear-gradient15);\n      }\n\n      .st20 {\n        fill: url(#linear-gradient17);\n      }\n\n      .st21 {\n        fill: url(#linear-gradient6);\n      }\n\n      .st22 {\n        fill: url(#linear-gradient13);\n      }\n\n      .st23 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 31.13,
    y1: 90.57,
    x2: 31.13,
    y2: 42.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92fe9d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 68.87,
    x2: 68.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 50,
    y1: 94.93,
    x2: 50,
    y2: 42.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: 50,
    y1: 78.99,
    x2: 50,
    y2: 94.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92fe7a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: 26.19,
    y1: 46.69,
    x2: 26.19,
    y2: 67.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient5",
    x1: 73.81,
    y1: 46.69,
    x2: 73.81,
    y2: 67.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient6",
    x1: 20.86,
    y1: 73.35,
    x2: 20.86,
    y2: -5.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient7",
    x1: 79.14,
    y1: 73.35,
    x2: 79.14,
    y2: -5.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient8",
    x1: 4.69,
    y1: 22.41,
    x2: 25.41,
    y2: 43.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient9",
    x1: 102.88,
    y1: 18.04,
    x2: 66.54,
    y2: 50.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient10",
    x1: 89.44,
    y1: 14.06,
    x2: 20.09,
    y2: 64.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient11",
    x1: 50,
    y1: 5.07,
    x2: 50,
    y2: 80.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient12",
    x1: 50,
    y1: 10.93,
    x2: 50,
    y2: 74.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient13",
    x1: 50,
    y1: 75.73,
    x2: 50,
    y2: 18.75,
    xlinkHref: "#linear-gradient3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient14",
    x1: 50,
    y1: 23.52,
    x2: 50,
    y2: 57.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient15",
    x1: 56.28,
    y1: 26.18,
    x2: 45.79,
    y2: 53.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient16",
    x1: 44.85,
    y1: 30.69,
    x2: 44.85,
    y2: 42.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient17",
    x1: 55.15,
    y1: 42.58,
    x2: 55.15,
    y2: 30.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient18",
    x1: 50,
    y1: 42.58,
    x2: 50,
    y2: 42.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffe771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e67700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient19",
    x1: 55.15,
    y1: 48.53,
    x2: 55.15,
    y2: 36.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient20",
    x1: 55.15,
    y1: 54.47,
    x2: 55.15,
    y2: 42.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient21",
    x1: 44.85,
    y1: 42.58,
    x2: 44.85,
    y2: 54.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient22",
    x1: 44.85,
    y1: 48.53,
    x2: 44.85,
    y2: 36.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient23",
    x1: 50,
    y1: 33.98,
    x2: 50,
    y2: 44.95,
    xlinkHref: "#linear-gradient"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "28.65 82.6 33.6 85.46 33.6 42.58 28.65 42.58 28.65 82.6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "66.4 42.58 66.4 85.46 71.35 82.6 71.35 42.58 66.4 42.58"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "35.74 42.58 35.74 86.69 50 94.93 64.26 86.69 64.26 42.58 35.74 42.58"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "37.87 85.46 37.87 44.72 62.13 44.72 62.13 85.46 50 92.47 37.87 85.46"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M10.22,55.4l35.7,20.61v-25.96L6.46,27.27v21.61c0,2.69,1.44,5.18,3.77,6.52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M54.08,50.05v25.96l35.7-20.61c2.33-1.35,3.77-3.83,3.77-6.52v-21.61l-39.46,22.78Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M4.89,38.1l35.7,20.61v-25.96L1.13,9.96v21.61c0,2.69,1.44,5.18,3.77,6.52Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M59.41,32.74v25.96l35.7-20.61c2.33-1.35,3.77-3.83,3.77-6.52V9.96l-39.46,22.78Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M10.22,48.29l35.7,20.61v-25.96L6.46,20.16v21.61c0,2.69,1.44,5.18,3.77,6.52Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M54.08,42.94v25.96l35.7-20.61c2.33-1.35,3.77-3.83,3.77-6.52v-21.61l-39.46,22.78Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.93,53.97v-22.77c0-5.08-2.71-9.77-7.11-12.31l-19.72-11.38c-4.4-2.54-9.82-2.54-14.22,0l-19.72,11.38c-4.4,2.54-7.11,7.23-7.11,12.31v22.77c0,5.08,2.71,9.77,7.11,12.31l19.72,11.38c4.4,2.54,9.82,2.54,14.22,0l19.72-11.38c4.4-2.54,7.11-7.23,7.11-12.31Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M50,80.09c-2.55,0-5.1-.66-7.38-1.97l-19.72-11.38c-4.55-2.63-7.38-7.52-7.38-12.77v-22.77c0-5.25,2.83-10.15,7.38-12.77l19.72-11.38c4.55-2.63,10.2-2.63,14.75,0l19.72,11.38c4.55,2.63,7.38,7.52,7.38,12.77v22.77c0,5.25-2.83,10.15-7.38,12.77l-19.72,11.38c-2.27,1.31-4.82,1.97-7.38,1.97ZM50,6.14c-2.37,0-4.73.61-6.84,1.83l-19.72,11.38c-4.22,2.44-6.84,6.98-6.84,11.85v22.77c0,4.87,2.62,9.41,6.84,11.85l19.72,11.38c4.22,2.44,9.46,2.44,13.68,0l19.72-11.38c4.22-2.44,6.84-6.98,6.84-11.85v-22.77c0-4.87-2.62-9.41-6.84-11.85l-19.72-11.38c-2.11-1.22-4.48-1.83-6.84-1.83Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M50,74.23c-1.56,0-3.09-.41-4.44-1.19l-19.72-11.38c-2.74-1.58-4.44-4.53-4.44-7.7v-22.77c0-3.16,1.7-6.11,4.44-7.69l19.72-11.38c1.35-.78,2.89-1.19,4.44-1.19s3.09.41,4.44,1.19l19.72,11.38c2.74,1.58,4.44,4.53,4.44,7.7v22.77c0,3.16-1.7,6.11-4.44,7.7l-19.72,11.38c-1.35.78-2.89,1.19-4.44,1.19Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M50,69.97c-.81,0-1.61-.21-2.31-.62l-19.72-11.38c-1.43-.82-2.31-2.36-2.31-4v-22.77c0-1.65.89-3.18,2.31-4l19.72-11.38c.7-.41,1.5-.62,2.31-.62s1.61.21,2.31.62l19.72,11.38c1.43.82,2.31,2.36,2.31,4v22.77c0,1.65-.89,3.18-2.31,4l-19.72,11.38c-.7.41-1.5.62-2.31.62Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "37.04 50.07 37.04 35.1 50 27.61 62.96 35.1 62.96 50.07 50 57.55 37.04 50.07"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "38.78 49.06 38.78 36.1 50 29.63 61.22 36.1 61.22 49.06 50 55.54 38.78 49.06"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "50 30.69 50 30.69 39.7 36.64 50 42.58 50 30.69"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "50 42.58 60.3 36.64 60.3 36.64 50 30.69 50 42.58 50 42.58"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "50 42.58 50 42.58 50 42.58 50 42.58"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "50 42.58 60.3 48.53 60.3 36.64 50 42.58"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "50 42.58 50 54.47 50 54.47 60.3 48.53 60.3 48.53 50 42.58 50 42.58"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "39.7 48.53 39.7 48.53 50 54.47 50 42.58 39.7 48.53"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "50 42.58 39.7 36.64 39.7 36.64 39.7 48.53 50 42.58 50 42.58"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "50 34.76 50 34.76 43.22 38.67 43.22 38.67 43.22 46.5 43.22 46.5 50 50.41 50 50.41 56.78 46.5 56.78 46.5 56.78 38.67 56.78 38.67 50 34.76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumPackage);
export default __webpack_public_path__ + "static/media/PREMIUM-PACKAGE.9f289e105ea79b232a54dc73e3e91758.svg";
export { ForwardRef as ReactComponent };